const T_PREFIX = "inquiries";

export const inquiriesTrns = {
  title: `${T_PREFIX}.title`,

  addInquiryButton: `${T_PREFIX}.add-inquiry-btn`,
};

export const noInquiriesBannerTrns = {
  title: `${T_PREFIX}.no-inquiries-banner.title`,
  description: `${T_PREFIX}.no-inquiries-banner.description`,
  addInquiryWithFiltersButton: `${T_PREFIX}.no-inquiries-banner.add-inquiry-with-filters-btn`,
};
